export const debounce = (setter, delay) => {
    let timeoutId;
    return (val) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            setter(val);
        }, delay);
    };
};